import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/terminos',
    name: 'terminos.index',
    component: () => import('./views/TerminosAgenda.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'terminos.read',
      breadcrumb: 'Vencimientos',
    },
  },
]

export default routes
